// store/user.js
import createPersistedState from 'vuex-persistedstate'
import { getUserInfoAPI, checkTokenAPI } from '@/api/user'
import router from '@/router' // ⬅ 新增：拿到全局路由实例
import { Message } from 'element-ui' // 引入 ElementUI 的 Message 组件
/* ================ state ================ */
const state = {
  token: '', // 登录令牌
  userInfo: null // 用户信息对象
}

/* ================ mutations ================ */
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  CLEAR_USER(state) {
    state.token = ''
    state.userInfo = null
  }
}

/* ================ actions ================ */
const actions = {
  /** 保存 token */
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },

  /** 保存用户信息 */
  setUserInfo({ commit }, info) {
    commit('SET_USER_INFO', info)
  },

  /** 退出登录 */
  logout({ commit }) {
    // 清除 Vuex state
    commit('CLEAR_USER')
    
    // 清除 localStorage 中的持久化数据（vuex-persistedstate）
    localStorage.removeItem('user')
    localStorage.removeItem('my_site_vuex')
    
    // 跳转到首页
    router.replace('/home')
  },

  /**
   * 获取用户信息
   * - 需要 token 与 uid
   */
  async fetchUserInfo({ state, commit }) {
    try {
      if (!state.token) {
        throw new Error('No token found in state')
      }
      const userId = state.userInfo?.uid
      if (!userId) {
        throw new Error('No userId found in userInfo')
      }
      const res = await getUserInfoAPI(userId)
      // 根据接口实际返回格式修改
      if (res.code === 200) {
        commit('SET_USER_INFO', res.data)
      } else {
        throw new Error(res.msg || '获取用户信息失败')
      }
      return res
    } catch (error) {
      console.error('fetchUserInfo error:', error)
      throw error
    }
  },

  /**
   * 检测登录状态
   * - 若 token 无效或接口返回非 200，则清空本地用户信息并跳转到首页
   * - 返回布尔值表示当前登录是否有效
   */
  async checkLoginStatus({ state, commit }) {
    // 没有 token → 直接视为未登录
    if (!state.token) {
      commit('CLEAR_USER')
      return false
    }
    try {
      const res = await checkTokenAPI(state.token)
      if (res.data.is_valid) {
        return true
      }
      Message.error('登录已过期，请重新登录')
      // token 无效 → 清空并重定向
      commit('CLEAR_USER')
      return false
    } catch (error) {
      console.error('checkLoginStatus error:', error)
      commit('CLEAR_USER')
      return false
    }
  }
}

/* ================ getters ================ */
const getters = {
  token: (state) => state.token,
  userInfo: (state) => state.userInfo,
  isAuthenticated: (state) => !!state.token
}

/* ================ 持久化插件 ================ */
const userPersistPlugin = createPersistedState({
  key: 'user',
  // 这里只持久化本模块的 token 和 userInfo
  paths: ['user.token', 'user.userInfo']
})

/* ================ 导出模块 ================ */
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  // 把插件暴露出去给 store/index.js 使用
  plugin: userPersistPlugin
}
